module.exports = __webpack_public_path__ + "static/media/Layer-2745.2d1430c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Layer-2745.png
// module id = 1435
// module chunks = 0